__turbopack_context__.v({
  "copy": "RoutingVerification-module__I80aDa__copy",
  "details": "RoutingVerification-module__I80aDa__details",
  "evidence": "RoutingVerification-module__I80aDa__evidence",
  "evidenceHeading": "RoutingVerification-module__I80aDa__evidenceHeading",
  "eyebrow": "RoutingVerification-module__I80aDa__eyebrow",
  "fail": "RoutingVerification-module__I80aDa__fail",
  "finding": "RoutingVerification-module__I80aDa__finding",
  "footer": "RoutingVerification-module__I80aDa__footer",
  "header": "RoutingVerification-module__I80aDa__header",
  "heading": "RoutingVerification-module__I80aDa__heading",
  "intro": "RoutingVerification-module__I80aDa__intro",
  "metadata": "RoutingVerification-module__I80aDa__metadata",
  "outcome": "RoutingVerification-module__I80aDa__outcome",
  "outcomeIcon": "RoutingVerification-module__I80aDa__outcomeIcon",
  "outcomeTag": "RoutingVerification-module__I80aDa__outcomeTag",
  "pass": "RoutingVerification-module__I80aDa__pass",
  "report": "RoutingVerification-module__I80aDa__report",
  "skipped": "RoutingVerification-module__I80aDa__skipped",
  "status": "RoutingVerification-module__I80aDa__status",
  "switcher": "RoutingVerification-module__I80aDa__switcher",
  "table": "RoutingVerification-module__I80aDa__table",
  "title": "RoutingVerification-module__I80aDa__title",
});
